function createSortDropdown() {
  const customDropdown = document.querySelector('.custom-dropdown');

  if (!customDropdown) return;

  const dropdownToggle = customDropdown.querySelector('.dropdown-toggle');

  dropdownToggle.addEventListener('click', function () {
    customDropdown.classList.toggle('open');
  });

  // Close the dropdown when clicking outside of it
  document.addEventListener('click', function (event) {
    if (!customDropdown.contains(event.target)) {
      customDropdown.classList.remove('open');
    }
  });
}

function searchListingFilterResults() {

  const filterBlock = document.querySelector('#block-acha-facet-search');
  const form = document.querySelector('#block-acha-facet-search form');

  if (!filterBlock || !form) return;


    const toggleButton = document.createElement('button');
    toggleButton.textContent = 'Filter results';

    filterBlock.prepend(toggleButton);
    toggleButton.addEventListener('click', () => {
      form.classList.toggle('open');
      toggleButton.classList.toggle('active');
    });


}


function toggleGrantListingFilter() {
  const toggleButton = document.querySelector('.page-grant-listing .page-view-listing__filter .btn-toggle-filter');
  const form = document.querySelector('.page-grant-listing .page-view-listing__filter .filter-form-wrapper');

  if (!toggleButton || !form) return;

  toggleButton.addEventListener('click', () => {
    console.log('test');
    form.classList.toggle('open');
    toggleButton.classList.toggle('active');
  });
}

window.addEventListener('DOMContentLoaded', () => {
  createSortDropdown();
  searchListingFilterResults();
  toggleGrantListingFilter();
});
